import { render, staticRenderFns } from "./InfoDetailsNila.vue?vue&type=template&id=c543906a&scoped=true"
var script = {}
import style0 from "./InfoDetailsNila.vue?vue&type=style&index=0&id=c543906a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c543906a",
  null
  
)

export default component.exports